import { useTheme } from "@emotion/react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Button,
  Chip,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  ListItemIcon,
  Menu,
  MenuItem,
  Modal,
  Paper,
  Select,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import { alpha, Box, Stack } from "@mui/system";
import useStyles from "./styles";

import {
  Add,
  Clear,
  CommentOutlined,
  Delete,
  Edit,
  ExpandMore,
  ManageAccountsOutlined,
  MoreVert,
  Search,
  SellOutlined,
} from "@mui/icons-material";
import { useEffect, useMemo, useState } from "react";
import api from "../../../../../../services/api";
import InternoModalConfirmacaoSaida from "../../../../../../components/modalSaindoDaPagina";

export default function ConfigRoteiros() {
  const [roteiros, setRoteiros] = useState([]);
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [loadingRoteiros, setLoadingRoteiros] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openEditRoteiro, setOpenEditRoteiro] = useState(false);
  const [type, setType] = useState("ticket");
  const [snackbar, setSnackbar] = useState(null);
  const [roteiro, setRoteiro] = useState({
    type: "ticket",
    title: "",
    description: "",
  });
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [filterType, setFilterType] = useState("all");
  const openMenu = Boolean(anchorEl);
  const theme = useTheme();
  const styles = useStyles(theme);
  const [expanded, setExpanded] = useState(false);
  // Busca só depois da primeira abertura do accordion.
  const [jaAberto, setJaAberto] = useState(false);

  const handleExpansion = () => {
    setExpanded((prevExpanded) => !prevExpanded);
    setJaAberto(true);
  };

  const roteirosFiltrados = useMemo(() => {
    return roteiros.filter((item) => {
      const text = searchText.toLowerCase();

      const matchText =
        item?.title?.toLowerCase().includes(text) ||
        item?.description?.toLowerCase().includes(text) ||
        item?.type?.toLowerCase().includes(text);

      const matchType = filterType === "all" ? true : item.type === filterType;

      return matchText && matchType;
    });
  }, [roteiros, searchText, filterType]);

  const handleClickMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setType("ticket");
    setRoteiro({
      type: "ticket",
      title: "",
      description: "",
    });
  };

  useEffect(() => {
    if (!jaAberto) return;
    getRoteiros();
  }, [jaAberto]);

  const configStylesMetion = {
    ticket: {
      labelChip: "Ticket",
      colorPaper:
        theme.palette.mode === "light"
          ? alpha(theme.palette.colors.orange.medium, 0.2)
          : alpha(theme.palette.colors.orange.darker, 0.3),
      colorLabelChip: theme.palette.colors.orange.medium,
      iconCard: () => (
        <SellOutlined
          sx={{
            color: theme.palette.colors.orange.medium,
          }}
        />
      ),
    },
    os: {
      labelChip: "OS",
      colorPaper:
        theme.palette.mode === "light"
          ? alpha(theme.palette.colors.purple.medium, 0.2)
          : alpha(theme.palette.colors.purple.medium, 0.3),
      colorLabelChip: theme.palette.colors.purple.medium,
      iconCard: () => (
        <ManageAccountsOutlined
          sx={{
            color: theme.palette.colors.purple.medium,
          }}
        />
      ),
    },
  };
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setOpenEditRoteiro(false);
    setType("ticket");
    setOpenEditRoteiro(false);
    setRoteiro({
      type: "ticket",
      title: "",
      description: "",
    });
  };
  const handleChange = (event) => {
    setType(event.target.value);
    setRoteiro((prev) => ({ ...prev, type: event.target.value }));
    setError(false);
  };

  const getRoteiros = async () => {
    setLoadingRoteiros(true);
    try {
      const response = await api.get("/interno/find/roteirosPublicos");
      setRoteiros(response?.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoadingRoteiros(false);
    }
  };

  const createRoteiro = async () => {
    if (
      roteiro?.title?.trim() === "" ||
      roteiro?.description?.trim() === "" ||
      roteiro?.type?.trim() === ""
    ) {
      setError(true);
      return;
    }
    setError(false);
    try {
      const response = await api.post("/interno/create/roteirosPublicos", {
        data: roteiro,
      });
      setRoteiros((prev) => [...prev, response?.data]);
      setSnackbar({
        children: "Roteiro criado com sucesso!",
        severity: "success",
      });
    } catch (error) {
      console.error(error);
    } finally {
      handleClose();
    }
  };

  const deleteRoteiro = async () => {
    setLoading(true);
    try {
      const response = await api.post("/interno/delete/roteirosPublicos", {
        idRoteiro: roteiro?.id,
      });
      setRoteiros((prev) =>
        prev?.filter((prevRoteiro) => prevRoteiro?.id !== roteiro?.id),
      );
      setSnackbar({
        children: "Roteiro deletado com sucesso!",
        severity: "success",
      });
    } catch (err) {
      console.log(err);
      setSnackbar({
        children: "Erro ao deletar roteiro!",
        severity: "error",
      });
    } finally {
      setLoading(false);
      handleCloseMenu();
      setOpenDeleteConfirm(false);
      setRoteiro({
        type: "ticket",
        title: "",
        description: "",
      });
    }
  };

  const editRoteiro = async () => {
    try {
      const response = await api.post("/interno/edit/roteirosPublicos", {
        data: {
          title: roteiro?.title,
          description: roteiro?.description,
          type: roteiro?.type,
        },
        idRoteiro: roteiro?.id,
      });
      setRoteiros((prev) =>
        prev.map((roteiro) =>
          roteiro?.id === response?.data?.id ? response?.data : roteiro,
        ),
      );
      setSnackbar({
        children: "Roteiro editado com sucesso!",
        severity: "success",
      });
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: "Erro ao editar roteiro!",
        severity: "error",
      });
    } finally {
      handleClose();
      handleCloseMenu();
    }
  };

  return (
    <>
      <Accordion data-secao="roteiros" expanded={expanded} onChange={handleExpansion}>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Box sx={styles.containerHeader}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <CommentOutlined color="primary" />
              <Typography
                variant="h5"
                sx={{
                  ...styles.title,
                  width: { xs: "100%", md: "auto" },
                }}
              >
                Roteiros de atendimento
              </Typography>
            </Box>
            {expanded && (
              <Box onClick={(e) => e.stopPropagation()} sx={styles.boxHeader}>
                <TextField
                  size="small"
                  onClick={(e) => e.stopPropagation()}
                  onMouseDown={(e) => e.stopPropagation()}
                  onFocus={(e) => e.stopPropagation()}
                  placeholder="Buscar..."
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  sx={{
                    width: { xs: "100%", sm: "260px" },

                    order: { xs: 1, sm: 1 },
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search fontSize="small" />
                      </InputAdornment>
                    ),
                    endAdornment: searchText ? (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setSearchText("")}
                          edge="end"
                        >
                          <Clear />
                        </IconButton>
                      </InputAdornment>
                    ) : null,
                  }}
                />

                <FormControl
                  size="small"
                  sx={{
                    minWidth: { xs: "calc(50% - 8px)", sm: 140 },
                    flexGrow: { xs: 1, sm: 0 },
                    order: { xs: 2, sm: 2 },
                  }}
                >
                  <InputLabel>Tipo</InputLabel>
                  <Select
                    value={filterType}
                    label="Tipo"
                    onChange={(e) => setFilterType(e.target.value)}
                    onMouseDown={(e) => e.stopPropagation()}
                  >
                    <MenuItem value="all">Todos</MenuItem>
                    <MenuItem value="ticket">Ticket</MenuItem>
                    <MenuItem value="os">OS</MenuItem>
                  </Select>
                </FormControl>

                <Button
                  onClick={(e) => {
                    handleOpen();
                    e.stopPropagation();
                  }}
                  endIcon={<Add />}
                  variant="contained"
                  sx={{
                    width: { xs: "calc(50% - 8px)", sm: "auto" },
                    flexGrow: { xs: 1, sm: 0 },
                    order: { xs: 3, sm: 3 },
                    whiteSpace: "nowrap",
                  }}
                >
                  Criar
                </Button>
              </Box>
            )}
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <Paper variant="outlined" sx={{ p: 2, borderRadius: "16px" }}>
            {loadingRoteiros ? (
              <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
                <CircularProgress />
              </Box>
            ) : (
              <Box sx={styles.containerCards}>
                <Grid
                  container
                  spacing={1}
                  columns={{ xs: 2, sm: 4, md: 6, lg: 8, xl: 8, xxl: 8 }}
                >
                  {roteirosFiltrados.length > 0 ? (
                    roteirosFiltrados?.map((roteiro) => (
                      <Grid item xs={2} sm={2} md={3} lg={2}>
                        <Paper
                          key={roteiro.id}
                          elevation={0}
                          sx={styles.paperCard}
                        >
                          {/* Cabeçalho: Ícone + Titulo e Menu lateral */}
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1.5}
                            sx={{ mb: 2, width: "100%" }}
                          >
                            {/* Ícone de Destaque */}
                            <Box
                              sx={{
                                ...styles.boxIcon,
                                backgroundColor:
                                  configStylesMetion[roteiro?.type].colorPaper,
                              }}
                            >
                              {configStylesMetion[roteiro?.type].iconCard(
                                roteiro?.isPublic,
                              )}
                            </Box>

                            <Box sx={{ flex: 1, minWidth: 0 }}>
                              <Typography
                                variant="subtitle1"
                                noWrap
                                sx={{
                                  fontWeight: 700,
                                  lineHeight: 1.2,
                                  color: "text.primary",
                                }}
                                title={roteiro?.title}
                              >
                                {roteiro?.title}
                              </Typography>
                            </Box>

                            {/* Menu de Opções */}
                            <IconButton
                              onClick={(e) => {
                                handleClickMenu(e);
                                setRoteiro(roteiro);
                                setType(roteiro?.type);
                              }}
                              size="small"
                              sx={{ color: "text.disabled", ml: "auto" }}
                            >
                              <MoreVert fontSize="small" />
                            </IconButton>
                          </Stack>

                          {/* Descrição */}
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={styles.description}
                          >
                            {roteiro?.description}
                          </Typography>

                          {/* Footer do Card */}
                          <Box sx={styles.boxChip}>
                            <Chip
                              label={
                                configStylesMetion[roteiro?.type]?.labelChip
                              }
                              size="small"
                              sx={{
                                ...styles.chip,
                                backgroundColor:
                                  configStylesMetion[roteiro?.type].colorPaper,
                                color:
                                  configStylesMetion[roteiro?.type]
                                    .colorLabelChip,
                              }}
                            />
                          </Box>
                        </Paper>
                      </Grid>
                    ))
                  ) : (
                    <Box sx={styles.boxInfo}>
                      <Typography
                        variant="body1"
                        sx={{
                          color: "text.secondary",
                          fontWeight: 500,
                        }}
                      >
                        Nenhum roteiro encontrado
                      </Typography>
                    </Box>
                  )}
                </Grid>
              </Box>
            )}
          </Paper>

          <Modal open={open || openEditRoteiro} onClose={handleClose}>
            <Box
              sx={{
                ...styles.containerModal,
              }}
            >
              <Box sx={{ p: 2 }}>
                <Typography sx={{ fontWeight: "bold", fontSize: "20px" }}>
                  Criar novo Roteiro
                </Typography>
              </Box>

              <Box sx={{ p: 2, flex: 1, overflowY: "auto" }}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={10}>
                    <TextField
                      fullWidth
                      label="Titulo"
                      onChange={(e) =>
                        setRoteiro((prev) => ({
                          ...prev,
                          title: e.target.value,
                        }))
                      }
                      value={roteiro?.title}
                      error={error && roteiro?.title?.trim() === ""}
                      helperText={
                        error &&
                        roteiro?.title?.trim() === "" &&
                        "Campo obrigatório"
                      }
                      size="small"
                      sx={{ mb: 2 }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <FormControl size="small" fullWidth>
                      <InputLabel>Tipo</InputLabel>
                      <Select
                        size="small"
                        value={type}
                        error={error && roteiro?.type?.trim() === ""}
                        helperText={
                          error &&
                          roteiro?.type?.trim() === "" &&
                          "Campo obrigatório"
                        }
                        label="Tipo"
                        onChange={handleChange}
                      >
                        <MenuItem value={"ticket"}>Ticket</MenuItem>
                        <MenuItem value={"os"}>OS</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Descrição"
                      multiline
                      rows={8}
                      variant="outlined"
                      value={roteiro?.description}
                      onChange={(e) =>
                        setRoteiro((prev) => ({
                          ...prev,
                          description: e.target.value,
                        }))
                      }
                      error={error && roteiro?.description?.trim() === ""}
                      helperText={
                        error &&
                        roteiro?.description?.trim() === "" &&
                        "Campo obrigatório"
                      }
                      InputProps={{
                        inputComponent: "textarea",
                      }}
                      sx={{
                        width: "100%",
                        "& .MuiFilledInput-root": {
                          paddingTop: "20px",
                        },
                        "& textarea": {
                          resize: "vertical",
                          minHeight: "100px",
                          maxHeight: "400px",
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </Box>

              <Box sx={styles.containerActions}>
                <Button onClick={handleClose} variant="outlined" size="small">
                  Cancelar
                </Button>
                <Button
                  onClick={() => {
                    open && createRoteiro();
                    openEditRoteiro && editRoteiro();
                  }}
                  size="small"
                  variant="contained"
                >
                  Salvar
                </Button>
              </Box>
            </Box>
          </Modal>
          {!!snackbar && (
            <Snackbar
              open
              onClose={() => setSnackbar(null)}
              autoHideDuration={3000}
              anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
              <Alert {...snackbar} onClose={() => setSnackbar(null)} />
            </Snackbar>
          )}
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={openMenu}
            onClose={handleCloseMenu}
            slotProps={{
              list: {
                "aria-labelledby": "basic-button",
              },
            }}
          >
            <MenuItem onClick={() => setOpenEditRoteiro(true)}>
              <ListItemIcon>
                <Edit fontSize="small" />
              </ListItemIcon>
              <Typography variant="inherit">Editar</Typography>
            </MenuItem>

            <MenuItem
              onClick={() => setOpenDeleteConfirm(true)}
              sx={{ color: "error.main" }}
            >
              <ListItemIcon>
                <Delete fontSize="small" sx={{ color: "error.main" }} />
              </ListItemIcon>
              <Typography variant="inherit">Excluir</Typography>
            </MenuItem>
          </Menu>
          <InternoModalConfirmacaoSaida
            openConfirmacao={openDeleteConfirm}
            deleteLoad={loading}
            setOpenConfirmacao={setOpenDeleteConfirm}
            execute={deleteRoteiro}
            severity={"error"}
            title={"Atenção"}
            contentText={
              "Se você prosseguir com a operação, o roteiro será deletado permanentemente!"
            }
            confirmText={"Excluir"}
          />
        </AccordionDetails>
      </Accordion>
    </>
  );
}
